import { PropsWithChildren, ReactNode } from 'react';
import {
	PageHeaderActions,
	PageHeaderActionsLeft,
	PageHeaderActionsRight,
	PageHeaderContainer,
	PageHeaderCount,
	PageHeaderTitleContainer,
	PageTitle,
} from 'shared/_components/page/styles';

type PageHeaderProps = PropsWithChildren<{
	count: number;
	actionsLeft?: ReactNode;
	actionsRight?: ReactNode;
}>;

export default function PageHeader(props: PageHeaderProps) {
	const { children, count, actionsLeft, actionsRight } = props;

	return (
		<PageHeaderContainer>
			<PageHeaderTitleContainer>
				<PageTitle>{children}</PageTitle>
				{!!count && <PageHeaderCount>({count})</PageHeaderCount>}
			</PageHeaderTitleContainer>
			{!!(actionsLeft || actionsRight) && (
				<PageHeaderActions>
					{!!actionsLeft && <PageHeaderActionsLeft>{actionsLeft}</PageHeaderActionsLeft>}
					{!!actionsRight && <PageHeaderActionsRight>{actionsRight}</PageHeaderActionsRight>}
				</PageHeaderActions>
			)}
		</PageHeaderContainer>
	);
}
